/*@ngInject*/
const WizardActionHandlerUtil = function (reportActionUtil, submissionAction, submissionActionUtil, submissionTransition, quoteActionUtil,
                                          renewalTransition, endorsementActionUtil, modalUtil, quoteTransition, quoteAction, proposalAction,
                                          quoteMediator, proposalActionUtil, externalReportAction, policyIssuanceAction, policyIssuanceActionUtil,
                                          policyAction, policyActionUtil, policyCancellationAction, policyCancellationActionUtil, endorsementTransition,
                                          submissionMediator, functionActionUtil, policyRewriteActionUtil, policyRewriteTransition) {

    this.handleAction = function (action, file, quoteId, reportId, proposalId, policyId, policyIssuanceId, endorsementId, policyCancellationId, policyRewriteId) {
        var isQuote = action.context ? action.context.indexOf('quote') !== -1 : false,
            isReport = action.context ? action.context.indexOf('report') !== -1 : false,
            isPolicyIssuance = action.context ? action.context.indexOf('PolicyIssuance') !== -1 : false,
            isProposalAction = action.context ? action.context.indexOf('proposal') !== -1 : false,
            isPolicyCancellation = action.context ? action.context.indexOf('PolicyCancellation') !== -1 : false,
            isPolicyRewrite = action.context ? action.context.indexOf('PolicyRewrite') !== -1 : false,
            isPolicyReissue = action.context ? action.context.indexOf('PolicyReissue') !== -1 : false,
            isPolicy = action.context ? action.context.indexOf('policy') !== -1 : false,
            isEndorsement = action.context ? action.context.indexOf('Endorsement') !== -1 : false,
            submission,
            identifierName,
            identifier;

        if (action.enabled) {
            submission = submissionMediator.getCurrentSubmission();

            if (action.functionType) {
                if (isQuote) {
                    identifierName = 'quoteId';
                    identifier = quoteId;
                } else if (isEndorsement) {
                    identifierName = 'endorsementId';
                    identifier = endorsementId;
                } else if (isPolicyIssuance) {
                    identifierName = 'issuanceId';
                    identifier = policyIssuanceId;
                }
                functionActionUtil.handleAction(action, submission, identifierName, identifier);
            } else if (isQuote) {
                this.handleQuoteAction(action, submission, quoteId);
            } else if (isReport) {
                this.handleReportAction(action, submission, reportId);
            } else if (isPolicyIssuance) {
                this.handlePolicyIssuanceAction(action, submission, policyIssuanceId);
            } else if (isProposalAction) {
                this.handleProposalAction(action, submission, proposalId);
            } else if (isPolicyCancellation) {
                this.handlePolicyCancellationAction(action, submission, policyCancellationId);
            } else if (isEndorsement) {
                this.handleEndorsementAction(action, submission, endorsementId);
            } else if (isPolicyRewrite || isPolicyReissue) {
                this.handlePolicyRewriteAction(action, submission, policyRewriteId, isPolicyReissue);
            } else if (isPolicy) {
                this.handlePolicyAction(action, submission, policyId);
            } else {
                this.handleSubmissionAction(action, submission);
            }
        }
    };

    this.handleSubmissionAction = function (action, submission) {
        var isCreateReport = action.groupName === 'Reports';

        if (isCreateReport) {
            reportActionUtil.createReport(submission.id, action.name);
        } else {
            switch (action.name) {
                case submissionAction.SUBMIT_MODIFICATIONS:
                    submissionActionUtil.handleSubmitModifications(submission);
                    break;
                case submissionTransition.LOST:
                    submissionActionUtil.handleMarkSubmissionAsLost(submission);
                    break;
                case submissionAction.DISCARD_MODIFICATIONS:
                    submissionActionUtil.handleDiscardModifications(submission);
                    break;
                case submissionAction.ACKNOWLEDGE_MODIFICATIONS:
                    submissionActionUtil.handleAcknowledgeModifications(submission);
                    break;
                case submissionAction.ASSIGN_ACCOUNT:
                    submissionActionUtil.handleAssignAccount(submission);
                    break;
                case submissionTransition.CLEAR:
                    submissionActionUtil.handleClear(submission.id);
                    break;
                case submissionTransition.DECLINE:
                    submissionActionUtil.handleDecline(submission);
                    break;
                case submissionTransition.REJECT:
                    submissionActionUtil.handleReject(submission.id);
                    break;
                case submissionTransition.NOT_CLEAR:
                    submissionActionUtil.handleNotClear(submission.id);
                    break;
                case submissionTransition.CLEAR_READY:
                    submissionActionUtil.handleClearReady(submission.id);
                    break;
                case submissionTransition.REVERT_TO_CLEAR:
                    submissionActionUtil.handleRevertToClear(submission.id);
                    break;
                case submissionAction.COPY_SUBMISSION:
                    submissionActionUtil.handleCopySubmission(submission.id);
                    break;
                case submissionAction.CHECK_CLEARANCE:
                    submissionActionUtil.handleCheckClearance(submission.id);
                    break;
                case submissionTransition.REACTIVATE:
                    submissionActionUtil.handleReactivate(submission.id);
                    break;
                case submissionTransition.REEVALUATE:
                    submissionActionUtil.handleReevaluate(submission.id);
                    break;
                case submissionTransition.CREATE_QUOTE:
                    quoteActionUtil.getQuotableProductTemplates(submission.id);
                    break;
                case submissionAction.CREATE_PROPOSAL:
                    submissionActionUtil.getQuotableProductTemplates(submission.id);
                    break;
                case submissionTransition.SET_SUBMISSION_PRODUCTS:
                    submissionActionUtil.changeProducts(submission.id);
                    break;
                case submissionTransition.UPDATE_STATUS_REASON:
                    submissionActionUtil.updateStatusReason(submission.id);
                    break;
                case submissionAction.SUBMIT_APPLICATION:
                    submissionActionUtil.submitApplication(submission.id);
                    break;
                case submissionAction.MODIFY_APPLICATION:
                case submissionAction.MODIFY_SUBMISSION:
                case submissionAction.MODIFY_BOUND_SUBMISSION:
                    submissionActionUtil.modifySubmission(submission.id);
                    break;
                case submissionTransition.DELETE:
                    submissionActionUtil.delete(submission.id);
                    break;
                case submissionAction.DELETE_PRE_DRAFT:
                    submissionActionUtil.deletePreDraft(submission.id);
                    break;
                case submissionTransition.MAKE_APPLICATION:
                    submissionActionUtil.makeApplication(submission.id);
                    break;
                case submissionAction.REFER:
                    submissionActionUtil.referSubmission(submission.id);
                    break;
                case submissionAction.RETRACT_REFERRAL:
                    submissionActionUtil.retractReferral(submission.id);
                    break;
                case submissionAction.CLEAR_REFERRAL:
                    submissionActionUtil.clearReferral(submission.id);
                    break;
                case submissionAction.DECLINE_REFERRAL:
                    submissionActionUtil.declineReferral(submission.id);
                    break;
                case submissionAction.SPLIT_SUBMISSION:
                    submissionActionUtil.splitSubmission(submission.id);
                    break;
                case submissionAction.REWRITE_SUBMISSION:
                    submissionActionUtil.rewriteSubmission(submission.id);
                    break;
                case submissionTransition.RESUBMIT:
                    submissionActionUtil.resubmitSubmission(submission.id);
                    break;
                case renewalTransition.SUBMIT_RENEWAL:
                    submissionActionUtil.submitRenewal(submission.id);
                    break;
                case renewalTransition.SUBMIT_NON_RENEWAL:
                    submissionActionUtil.submitNonRenewal(submission.id);
                    break;
                case renewalTransition.RETRACT_NON_RENEWAL:
                    submissionActionUtil.retractNonRenewal(submission.id);
                    break;
                case renewalTransition.FLAG_FOR_NON_RENEWAL:
                    submissionActionUtil.flagForNonRenewal(submission.id);
                    break;
                case renewalTransition.CLEAR_NON_RENEWAL_FLAG:
                    submissionActionUtil.clearNonRenewalFlag(submission.id);
                    break;
                case submissionAction.DISABLE_AUTOMATION:
                    submissionActionUtil.disableAutomation(submission.id);
                    break;
                case submissionAction.DETAILED_HISTORY:
                    submissionActionUtil.openDetailedHistory(submission);
                    break;
                case submissionTransition.START_PREQUALIFICATION:
                    submissionActionUtil.startPrequalification(submission.id, action.preDraft);
                    break;
                case submissionTransition.CANCEL_PREQUALIFICATION:
                    submissionActionUtil.cancelPrequalification(submission.id, action.preDraft);
                    break;
                case submissionTransition.CHECK_PREQUALIFICATION:
                    submissionActionUtil.checkPrequalification(submission.id, action.preDraft);
                    break;
                case submissionTransition.SUBMIT_PREQUALIFICATION:
                    submissionActionUtil.submitPrequalification(submission.id);
                    break;
                case renewalTransition.MARK_EXPIRED:
                    submissionActionUtil.markExpired(submission.id);
                    break;
                case renewalTransition.MARK_NON_RENEWED:
                    submissionActionUtil.markNonRenewed(submission.id);
                    break;
                case renewalTransition.MARK_RENEWED:
                    submissionActionUtil.markRenewed(submission.id);
                    break;
                case submissionAction.CREATE_ENDORSEMENT:
                    endorsementActionUtil.startEndorsement(submission.id);
                    break;
                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    this.handleQuoteAction = function (action, submission, quoteId) {
        switch (action.name) {
            case quoteTransition.DECLINE_QUOTE:
                quoteActionUtil.handleDeclineToBind(quoteId, submission.id);
                break;
            case quoteTransition.DELETE:
                quoteActionUtil.deleteQuote(quoteId, submission.id);
                break;
            case quoteTransition.COPY_QUOTE:
                quoteActionUtil.copyQuote(quoteId, submission.id);
                break;
            case quoteAction.COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL:
                quoteActionUtil.copyQuoteForMultiQuoteProposal(quoteId, submission.id);
                break;
            case quoteAction.GENERATE_QUOTE:
                quoteActionUtil.generateQuote(quoteId, submission.id);
                break;
            case quoteTransition.MODIFY_QUOTE:
                quoteActionUtil.modifyQuote(quoteId, submission.id);
                break;
            case quoteTransition.START_QUOTE:
                quoteActionUtil.startQuote(quoteId, submission.id);
                break;
            case quoteTransition.GENERATE_RATING:
                quoteActionUtil.generateRating(quoteId, submission.id);
                break;
            case quoteTransition.START_PRICING:
                quoteActionUtil.startPricing(quoteId, submission.id);
                break;
            case quoteTransition.MODIFY_PRICING:
                quoteActionUtil.modifyPricing(quoteId, submission.id);
                break;
            case quoteTransition.MODIFY_RATING:
                quoteActionUtil.modifyRating(quoteId, submission.id);
                break;
            case quoteTransition.SEND:
                quoteActionUtil.sendProposal(quoteId, submission.id);
                break;
            case quoteTransition.BEGIN_BINDING:
                quoteActionUtil.beginBinding(quoteId, submission.id);
                break;
            case quoteTransition.REQUEST_BINDING:
                quoteActionUtil.requestBinding(quoteId, submission.id);
                return;
            case quoteTransition.BIND:
                quoteActionUtil.bindQuote(quoteId, submission.id);
                return;
            case proposalAction.SEND_BINDER:
                quoteMediator.getQuote(quoteId).then(function (quote) {
                    proposalActionUtil.sendBinder(submission.id, quote.proposalId);
                }.bind(this));
                return;
            case quoteTransition.GENERATE_BINDER:
                quoteActionUtil.generateBinder(quoteId, submission.id);
                return;
            case quoteAction.ADD_DOCUMENT:
                quoteActionUtil.addQuoteDocument(submission.id, quoteId);
                return;
            case quoteTransition.UNBIND:
                quoteActionUtil.unbind(quoteId, submission.id);
                return;
            case quoteAction.REFRESH_QUOTE:
                var quoteIds = [quoteId];
                quoteActionUtil.refreshQuoteByIds(quoteIds);
                return;
            case quoteTransition.MODIFY_BINDER:
                quoteActionUtil.modifyBinder(quoteId, submission.id);
                return;
            case quoteAction.ADD_SECTION:
                quoteActionUtil.addSection(quoteId, submission.id);
                return;
            case quoteAction.DELETE_SECTION:
                quoteActionUtil.deleteSection(quoteId, submission.id);
                return;
            case quoteAction.GENERATE_RATING_ATTACHMENTS:
                quoteActionUtil.generateRatingAttachments(quoteId, submission.id);
                return;
            case quoteAction.REVERT_TO_SENT:
                quoteActionUtil.revertToSent(quoteId, submission.id);
                break;
            case quoteTransition.WITHDRAW_QUOTE:
                quoteActionUtil.withdrawQuote(quoteId, submission.id);
                break;
            case quoteTransition.WITHDRAW_REQUEST:
                quoteActionUtil.withdrawRequest(quoteId, submission.id);
                break;
            default:
                modalUtil.showActionNotImplementedModal(action.name);
                break;
        }
    };

    this.handleReportAction = function (action, submission, reportId) {
        switch (action.name) {
            case externalReportAction.GENERATE_REPORT:
                reportActionUtil.generateReport(reportId);
                break;
            case externalReportAction.DELETE_REPORT:
                reportActionUtil.deleteReport(submission.id, reportId);
                break;
            case externalReportAction.EDIT_REPORT:
                reportActionUtil.editReport(reportId);
                break;
            default:
                modalUtil.showActionNotImplementedModal(action.name);
                break;
        }
    };

    this.handlePolicyIssuanceAction = function (action, submission, policyIssuanceId) {
        switch (action.name) {
            case policyIssuanceAction.BEGIN_ISSUANCE:
                policyIssuanceActionUtil.beginIssuance(policyIssuanceId);
                break;
            case policyIssuanceAction.REVERT_TO_BOUND:
                policyIssuanceActionUtil.revertToBound(submission.id, policyIssuanceId);
                break;
            case policyIssuanceAction.SUBMIT_FOR_ISSUANCE:
                policyIssuanceActionUtil.submitForIssuance(submission.id, policyIssuanceId);
                break;
            case policyIssuanceAction.MODIFY_ISSUANCE:
                policyIssuanceActionUtil.modifyIssuance(policyIssuanceId);
                break;
            case policyIssuanceAction.MARK_AS_ISSUED:
                policyIssuanceActionUtil.markAsIssued(submission.id, policyIssuanceId);
                break;
            case policyIssuanceAction.REVERT_TO_PENDING_ISSUANCE:
                policyIssuanceActionUtil.revertToPendingIssuance(submission.id, policyIssuanceId);
                break;
            default:
                modalUtil.showActionNotImplementedModal(action.name);
                break;
        }
    };

    this.handleProposalAction = function (action, submission, proposalId) {
        switch (action.name) {
            case proposalAction.COPY_PROPOSAL:
                proposalActionUtil.copyProposal(submission.id, proposalId);
                break;
            case proposalAction.MODIFY_PROPOSAL:
                proposalActionUtil.modifyProposal(proposalId, submission.id);
                break;
            case proposalAction.DELETE_PROPOSAL:
                proposalActionUtil.deleteProposal(submission.id, proposalId);
                break;
            case proposalAction.CREATE_QUOTE:
                proposalActionUtil.getQuotableProductTemplates(submission.id, proposalId);
                break;
            case proposalAction.SEND_PROPOSAL:
                proposalActionUtil.sendProposal(submission.id, proposalId);
                break;
            case proposalAction.BEGIN_BINDING_PROPOSAL:
                proposalActionUtil.beginBinding(submission.id, proposalId);
                break;
            case proposalAction.DECLINE_TO_BIND_PROPOSAL_FROM_SENT:
                proposalActionUtil.declineToBindFromSent(submission.id, proposalId);
                break;
            case proposalAction.DECLINE_TO_BIND_PROPOSAL:
                proposalActionUtil.declineToBind(submission.id, proposalId);
                break;
            case proposalAction.REQUEST_TO_BIND_PROPOSAL_FROM_SENT:
                proposalActionUtil.requestToBindFromSent(submission.id, proposalId);
                break;
            case proposalAction.REQUEST_TO_BIND_PROPOSAL:
                proposalActionUtil.requestBinding(submission.id, proposalId);
                break;
            case proposalAction.BIND_PROPOSAL_FROM_SENT:
                proposalActionUtil.bindProposalFromSent(submission.id, proposalId);
                break;
            case proposalAction.ADD_DOCUMENT:
                proposalActionUtil.addProposalDocument(submission.id, proposalId);
                break;
            case proposalAction.SEND_BINDER:
                proposalActionUtil.sendBinder(submission.id, proposalId);
                break;
            case proposalAction.BIND_PROPOSAL:
                proposalActionUtil.bindProposal(submission.id, proposalId);
                break;
            case proposalAction.ADD_SECTION:
                proposalActionUtil.addSection(submission.id, proposalId);
                break;
            case proposalAction.DELETE_SECTION:
                proposalActionUtil.deleteSection(submission.id, proposalId);
                break;
            case proposalAction.GENERATE_BINDER_PROPOSAL:
                proposalActionUtil.generateBinder(submission.id, proposalId);
                break;
            case proposalAction.GENERATE_QUOTES:
                proposalActionUtil.generateQuotes(submission.id, proposalId);
                break;
            default:
                modalUtil.showActionNotImplementedModal(action.name);
                break;
        }
    };

    this.handlePolicyAction = function (action, submission, policyId) {
        switch (action.name) {
            case policyAction.CANCEL:
                policyActionUtil.cancel(policyId);
                break;
            case policyAction.REINSTATE:
                policyActionUtil.reinstatePolicy(submission.id, policyId);
                break;
            case policyAction.ENDORSE:
                policyActionUtil.startEndorsement(policyId);
                break;
            case policyAction.REWRITE:
                policyActionUtil.startPolicyRewrite(policyId);
                break;
            case policyAction.REISSUE:
                policyActionUtil.startPolicyReissue(policyId);
                break;
            default:
                modalUtil.showActionNotImplementedModal(action.name);
                break;
        }
    };

    this.handlePolicyCancellationAction = function (action, submission, policyCancellationId) {
        switch (action.name) {
            case policyCancellationAction.REQUEST_CANCELLATION:
                policyCancellationActionUtil.requestCancellation(policyCancellationId);
                break;
            case policyCancellationAction.SUBMIT_FOR_CANCELLATION:
                policyCancellationActionUtil.submitForCancellation(policyCancellationId);
                break;
            case policyCancellationAction.MARK_AS_CANCELLED:
                policyCancellationActionUtil.markAsCancelled(policyCancellationId);
                break;
            case policyCancellationAction.DELETE_DRAFT_CANCELLATION:
                policyCancellationActionUtil.deleteDraftCancellation(submission.id, policyCancellationId);
                break;
            case policyCancellationAction.RETRACT_CANCELLATION_REQUEST:
                policyCancellationActionUtil.retractCancellationRequest(submission.id, policyCancellationId);
                break;
            case policyCancellationAction.RESCIND_CANCELLATION:
                policyCancellationActionUtil.rescindCancellation(submission.id, policyCancellationId);
                break;
            case policyCancellationAction.REVERT_TO_CANCELLATION_PENDING:
                policyCancellationActionUtil.revertToCancellationPending(submission.id, policyCancellationId);
                break;
            default:
                modalUtil.showActionNotImplementedModal(action.name);
                break;
        }
    };

    this.handleEndorsementAction = function (action, submission, endorsementId) {
        switch (action.name) {
            case endorsementTransition.CREATE:
                endorsementActionUtil.createEndorsement(endorsementId);
                break;
            case endorsementTransition.DELETE:
                endorsementActionUtil.deleteEndorsement(endorsementId, submission.id);
                break;
            case endorsementTransition.REFRESH_QUOTE:
                endorsementActionUtil.refreshQuote(endorsementId, submission.id);
                break;
            case endorsementTransition.SUBMIT:
                endorsementActionUtil.submitEndorsement(endorsementId, submission.id);
                break;
            case endorsementTransition.CREATE_ENDORSEMENT_QUOTE:
                endorsementActionUtil.startRating(endorsementId);
                break;
            case endorsementTransition.SUBMIT_FOR_ISSUANCE:
                endorsementActionUtil.submitEndorsementForIssuance(endorsementId);
                break;
            case endorsementTransition.MARK_AS_ISSUED:
                endorsementActionUtil.markEndorsementAsIssued(endorsementId, submission.id);
                break;
            case endorsementTransition.REVERT_TO_SUBMITTED:
                endorsementActionUtil.revertEndorsementToSubmitted(endorsementId);
                break;
            case endorsementTransition.APPROVE:
                endorsementActionUtil.approveEndorsement(endorsementId, submission.id);
                break;
            case endorsementTransition.DECLINE:
                endorsementActionUtil.declineEndorsement(endorsementId, submission.id);
                break;
            case endorsementTransition.GENERATE_RATING:
                endorsementActionUtil.generateRating(endorsementId, submission.id);
                break;
            case endorsementTransition.GENERATE_RATING_ATTACHMENTS:
                endorsementActionUtil.generateRatingAttachments(endorsementId, submission.id);
                break;
            case endorsementTransition.START_PRICING:
                endorsementActionUtil.startPricing(endorsementId, submission.id);
                break;
            case endorsementTransition.MODIFY_RATING:
                endorsementActionUtil.modifyRating(endorsementId, submission.id);
                break;
            case endorsementTransition.MODIFY_PRICING:
                endorsementActionUtil.modifyPricing(endorsementId, submission.id);
                break;
            case endorsementTransition.REVIEW_CHANGES:
                endorsementActionUtil.reviewChanges(endorsementId);
                break;
            case endorsementTransition.REVERT_TO_PENDING_ISSUANCE:
                endorsementActionUtil.revertToPendingIssuance(endorsementId);
                break;
            default:
                modalUtil.showActionNotImplementedModal(action.name);
                break;
        }
    };

    this.handlePolicyRewriteAction = function (action, submission, policyRewriteId, isReissue) {
        switch (action.name) {
            case policyRewriteTransition.CREATE:
                policyRewriteActionUtil.createPolicyRewrite(policyRewriteId, isReissue);
                break;
            case policyRewriteTransition.DELETE:
                policyRewriteActionUtil.deletePolicyRewrite(policyRewriteId, submission.id, isReissue);
                break;
            case policyRewriteTransition.REFRESH_QUOTE:
                policyRewriteActionUtil.refreshQuote(policyRewriteId, isReissue);
                break;
            case policyRewriteTransition.SUBMIT:
                policyRewriteActionUtil.submitPolicyRewrite(policyRewriteId, isReissue);
                break;
            case policyRewriteTransition.START_RATING:
                policyRewriteActionUtil.startRating(policyRewriteId, isReissue);
                break;
            case policyRewriteTransition.SUBMIT_FOR_ISSUANCE:
                policyRewriteActionUtil.submitPolicyRewriteForIssuance(policyRewriteId, isReissue);
                break;
            case policyRewriteTransition.MARK_AS_ISSUED:
                policyRewriteActionUtil.markPolicyRewriteAsIssued(policyRewriteId, submission.id, isReissue);
                break;
            case policyRewriteTransition.REVERT_TO_SUBMITTED:
                policyRewriteActionUtil.revertPolicyRewriteToSubmitted(policyRewriteId, isReissue);
                break;
            case policyRewriteTransition.GENERATE_RATING:
                policyRewriteActionUtil.generateRating(policyRewriteId);
                break;
            case policyRewriteTransition.GENERATE_RATING_ATTACHMENTS:
                policyRewriteActionUtil.generateRatingAttachments(policyRewriteId, submission.id);
                break;
            case policyRewriteTransition.START_PRICING:
                policyRewriteActionUtil.startPricing(policyRewriteId);
                break;
            case policyRewriteTransition.MODIFY_RATING:
                policyRewriteActionUtil.modifyRating(policyRewriteId);
                break;
            case policyRewriteTransition.MODIFY_PRICING:
                policyRewriteActionUtil.modifyPricing(policyRewriteId);
                break;
            case policyRewriteTransition.REVIEW_CHANGES:
                policyRewriteActionUtil.reviewChanges(policyRewriteId, isReissue);
                break;
            default:
                modalUtil.showActionNotImplementedModal(action.name);
                break;
        }
    };
};

angular.module('gw-um-submission')
    .service('wizardActionHandlerUtil', WizardActionHandlerUtil);
